<div class="row">

  <div class="col-md-12">
    <h1>Automatischer Rechnungslauf</h1>
  </div>

  <div class="col-md-6">
    <h2>Rechnungslauf starten</h2>

    <form class="form-horizontal" [formGroup]="form">

      <div class="form-group">
        <date-range cssClass="no-margin-fg" [start]="null" [end]="null" (update)="updateDateRange($event)"></date-range>
      </div>

      <div class="form-group">
        <label for="date" class="col-sm-2 control-label">RG-Datum</label>
        <div class="col-sm-10">
          <ev-datepicker id="date" formControlName="date" class="form-control datepicker-width-120"></ev-datepicker>
        </div>
      </div>

      <div class="form-group">
        <label for="sending_instant" class="col-sm-2 control-label">RGs automatisch nach Erstellung übermitteln</label>
        <div class="col-sm-10">
          <input type="checkbox" id="sending_instant" style="width:40px;" formControlName="sending_instant" class="form-control" />
        </div>
      </div>

      <h3>Ausgewählte Lieferscheine: {{ count }}</h3>

      <button type="button" class="btn btn-success" (click)="create()" [disabled]="disabled || form.invalid">
        Erstellen
      </button>

    </form>
  </div>

  <div class="col-md-6">

    <ul ngbNav #nav="ngbNav" class="nav-tabs">

      <li ngbNavItem class="nav-item">
        <a ngbNavLink>Fehlerhafte Aufträge</a>
        <ng-template ngbNavContent>
          <button (click)="refresh('error')" title="Liste aktualisieren" class="btn btn-link">
            Aktualisieren <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>

          <table class="table whitetable">
            <thead>
              <tr class="filterrow">
                <th>Lieferschein-ID</th>
                <th>Benutzer</th>
                <th>Fehler</th>
                <th>erneut versuchen</th>
                <th>Ausblenden</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of errors; track obj; let index = $index) {
                <tr>
                  <td>
                    <ev-file-button [objId]="obj.delivery_id" type="delivery">
                      {{ obj.delivery_id }}
                    </ev-file-button>
                  </td>
                  <td>{{ obj.username }}</td>
                  <td>
                    @if (obj.status!=='working') {
                      @switch (obj.error) {
                        <!-- errors from sending -->
                        @case ('ENVISIA2') {
                          Fehler beim versenden per Post
                        }
                        @case ('ENVISIA101') {
                          Fehler beim versenden per E-Mail
                        }
                        <!-- errors from automation -->
                        @case ('delivery not found') {
                          Lieferschein existiert nicht
                        }
                        @case ('delivery storno') {
                          Lieferschein wurde storniert
                        }
                        @case ('delivery locked') {
                          Lieferschein ist gesperrt
                        }
                        @case ('invoice not found') {
                          Rechnung existiert nicht
                        }
                        @case ('invoice storno') {
                          Rechnung wurde storniert
                        }
                        @case ('invoice creating error') {
                          Fehler beim erstellen der Rechnung
                        }
                        @case ('user not set') {
                          Benutzer fehlt oder hat keine Berechtigung
                        }
                        @case ('sending maximum reruns') {
                          Konnte nicht versendet werden
                        }
                        <!-- errors from scala invoice creation -->
                        @case ('position') {
                          Fehler in Position
                        }
                        @case ('vat') {
                          Fehlerhafte USt.-ID
                        }
                        @default {
                          Unbekannter Fehler
                        }
                      }
                    }
                    @if (obj.status==='working') {
                      Auftrag stehengeblieben
                    }
                  </td>
                  <td>
                    <button type="button" class="btn btn-link btn-sm" (click)="restart(index, obj)">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                    </button>
                  </td>
                  <td>
                    <button type="button" class="btn btn-link btn-sm" (click)="hide(index, obj)">
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ng-template>
      </li>

      <li ngbNavItem class="nav-item">
        <a ngbNavLink>Aufträge in Bearbeitung</a>
        <ng-template ngbNavContent>

          <button (click)="refresh('working')" title="Liste aktualisieren" class="btn btn-link">
            Aktualisieren <i class="fa fa-refresh" aria-hidden="true"></i>
          </button>

          <table class="table whitetable">
            <thead>
              <tr class="filterrow">
                <th>Lieferschein-ID</th>
                <th>Benutzer</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              @for (obj of working; track obj; let index = $index) {
                <tr>
                  <td>
                    <ev-file-button [objId]="obj.delivery_id" type="delivery">
                      {{ obj.delivery_id }}
                    </ev-file-button>
                  </td>
                  <td>{{ obj.username }}</td>
                  <td>
                    @switch (obj.status) {
                      @case ('created') {
                        Erstellt
                      }
                      @case ('working') {
                        In Bearbeitung
                      }
                      @case ('created_invoice') {
                        Rechnung erstellt
                      }
                      @case ('sending_queued') {
                        Warteschlange Versand
                      }
                      @case ('sending') {
                        Wird versendet
                      }
                      @case ('sending_done') {
                        Übermittelt
                      }
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </ng-template>
      </li>

    </ul>

    <div [ngbNavOutlet]="nav"></div>
  </div>


</div>
